import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-facilities-create',
  templateUrl: './facilities-create.component.html',
  styleUrls: ['./facilities-create.component.scss']
})
export class FacilitiesCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public facilitiesoverviewForm: FormGroup;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/facilitiesoverviewbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.facilitiesoverviewForm.patchValue({
              _id: data.data._id,
              imagealt: data.data.imagealt,
              imagetitle: data.data.imagetitle,
              subtitle: data.data.subtitle,
              image: data.data.image,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.facilitiesoverviewForm = this.formBuilder.group({
      image: ['', Validators.required],
      imagealt: ['', Validators.required],
      imagetitle: ['', Validators.required],
      subtitle: ['', Validators.required],
      _id: ['']
    })
  }

  get f() { return this.facilitiesoverviewForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.facilitiesoverviewForm.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "image" : this.facilitiesoverviewForm.value.image,
      "imagealt" : this.facilitiesoverviewForm.value.imagealt,
      "imagetitle" : this.facilitiesoverviewForm.value.imagetitle,
      "subtitle" : this.facilitiesoverviewForm.value.subtitle,
      "admin" : sessionStorage.getItem('adminName'),
    };
    console.log(data);
    this.http.post<any>(this.api_endpoint+'/facilitiesoverview', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/facilitiesoverview/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
  }else{
    var data1 = {
      "image" : this.facilitiesoverviewForm.value.image,
      "imagealt" : this.facilitiesoverviewForm.value.imagealt,
      "imagetitle" : this.facilitiesoverviewForm.value.imagetitle,
      "subtitle" : this.facilitiesoverviewForm.value.subtitle,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.facilitiesoverviewForm.value._id,
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/facilitiesoverview/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/facilitiesoverview/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
